import { Config } from "@/models/Config";
import configData from "../data/config.json";

const config: Config = configData as Config;

export default {
  loginUrl: config.serverUrl + "login",
  logoutUrl: config.serverUrl + "Authentication/LogoutFromFrontClient",
  campaignAppDataUrl: config.serverUrl + "Channels/_AppData",
  campaignAssetsDataUrl: config.serverUrl + "Channels/_AssetsData",
  connectionAlertsActiveUrl: config.serverUrl + "ConnectionAlerts/Active",
  clientAutoCompletePropertiesUrl: config.serverUrl + "Channels/_AutoCompleteProperties",
  campaignTagsDataUrl: config.serverUrl + "Channels/_ChannelTagsData",
  campaignCostsDataUrl: config.serverUrl + "Channels/_CostsData",
  campaignCRMDataUrl: config.serverUrl + "Channels/_CRMData",
  campaignFacebookDataUrl: config.serverUrl + "Channels/_FacebookData",
  campaignFinishDataUrl: config.serverUrl + "Channels/_FinishData",
  campaignGoalsDataUrl: config.serverUrl + "Channels/_GoalsData",
  campaignGoogleDataUrl: config.serverUrl + "Channels/_GoogleData",
  campaignPhonesDataUrl: config.serverUrl + "Channels/_PhonesData",
  campaignProjectsDataUrl: config.serverUrl + "Channels/_ProjectPerformanceData",
  saveCampaignAppUrl: config.serverUrl + "Channels/_SaveAppFromBody",
  saveCampaignAssetsUrl: config.serverUrl + "Channels/_SaveAssetsFromBody",
  saveCampaignTagsUrl: config.serverUrl + "Channels/_SaveChannelTagsFromBody",
  saveCampaignCostUrl: config.serverUrl + "Channels/_SaveCostFromBody",
  saveCampaignCRMUrl: config.serverUrl + "Channels/_SaveCRMFromBody",
  saveCampaignFacebookUrl: config.serverUrl + "Channels/_SaveFacebookFromBody",
  saveCampaignGeneralInfoUrl: config.serverUrl + "Channels/_SaveGeneralInfoFromBody",
  saveCampaignGoalsUrl: config.serverUrl + "Channels/_SaveGoalsFromBody",
  saveCampaignGoogleUrl: config.serverUrl + "Channels/_SaveGoogleFromBody",
  saveCampaignMetadataTypeUrl: config.serverUrl + "Channels/_SaveMetadataTypeFromBody",
  campaignSavePhonesUrl: config.serverUrl + "Channels/_SavePhonesFromBody",
  saveCampaignProjectsUrl: config.serverUrl + "Channels/_SaveProjectPerformanceFromBody",
  saveCampaignWhatsappPhonesUrl: config.serverUrl + "Channels/_SaveWhatsAppPhoneFromBody",
  campaignSetActiveUrl: config.serverUrl + "Channels/_SetActiveFromBody",
  campaignWhatsAppPhonesDataUrl: config.serverUrl + "Channels/_WhatsAppPhonesData",
  changeDefaultCampaignAssetUrl: config.serverUrl + "Channels/ChangeDefaultChannelAsset",
  campaignAssetsUrl: config.serverUrl + "Channels/ChannelAssets_Read",
  campaignsUrl: config.serverUrl + "Channels/Channels_Read",
  campaignsWithStatsUrl: config.serverUrl + "Channels/CampaignsStatistic",
  campaignAdGroups: config.serverUrl + "Channels/ChannelsAdGroups_Read",
  campaignKeywords: config.serverUrl + "Channels/ChannelsAdGroupsAdDetailKeywords_Read",
  campaignAds: config.serverUrl + "Channels/ChannelsAdGroupsDetail_Read",
  campaignCheckPhonesUrl: config.serverUrl + "Channels/CheckPhones",
  deleteCampaignUrl: config.serverUrl + "Channels/DeleteChannel",
  exportCampaignsToExcelUrl: config.serverUrl + "Channels/ExportToExcel",
  campaignUrl: config.serverUrl + "Channels/GetCampaign",
  campaignsPageDataUrl: config.serverUrl + "Channels/GetCampaignsPageData",
  getAdPreviewDataUrl: config.serverUrl + "Channels/GetAdPreviewData",
  campaignProjectListUrl: config.serverUrl + "Channels/ProjectList",
  campaignProjectPagesListUrl: config.serverUrl + "Channels/ProjectPagesList",
  campaignRenewPhoneUrl: config.serverUrl + "Channels/RenewPhoneFromBody",
  campaignSendMessageUrl: config.serverUrl + "Channels/SendMessage",
  campaignToggleActiveUrl: config.serverUrl + "Channels/ToggleEnabled",
  campaignTogglePhoneStateUrl: config.serverUrl + "Channels/TogglePhoneStateFromBody",
  deleteLeadUrl: config.serverUrl + "ContactForms/Delete",
  updateLeadUrl: config.serverUrl + "ContactForms/Edit",
  updateClientUrl: config.serverUrl + "ContactForms/EditClient",
  exportLeadsToExcelUrl: config.serverUrl + "ContactForms/ExportToExcel",
  exportLeadsToExcelToMailUrl: config.serverUrl + "ContactForms/ExportExcelToMail",
  leadUrl: config.serverUrl + "ContactForms/GetLead",
  clientUrl: config.serverUrl + "ContactForms/GetClient",
  leadsPageDataUrl: config.serverUrl + "ContactForms/GetLeadsPageData",
  leadHistoryUrl: config.serverUrl + "ContactForms/Lead_History",
  contactFormsUrl: config.serverUrl + "ContactForms/Leads_Read",
  leadsStatisticCallsByDateUrl: config.serverUrl + "ContactForms/LeadsStatistic_CallsByDate",
  leadsStatisticAllUrl: config.serverUrl + "ContactForms/LeadsStatistic_DealMeetingsLeads",
  additionalStatusesUrl: config.serverUrl + "ContactForms/SaleStatusList_Read",
  assigneesUrl: config.serverUrl + "ContactForms/Salesmans_Read",
  checkPhonePopupUrl: config.serverUrl + "ContactForms/CheckPhonePopup",
  setHidePopupCookieUrl: config.serverUrl + "ContactForms/SetHidePhonePopupCookie",
  setLanguageUrl: config.serverUrl + "Admin/SetLanguage",
  explanationPopupUrl: config.serverUrl + "ExplanationModule/GetPopup",
  explanationSaveImageFile: config.serverUrl + "ExplanationModule/SaveImageFile",
  explanationSendEmailUrl: config.serverUrl + "ExplanationModule/SendEmail",
  explanationSendAlgoliaPost: config.serverUrl + "ExplanationModule/AlgoliaPost",
  editExternalServiceUrl: config.serverUrl + "ExternalServices/Edit",
  facebookCheckChannelCampaignsUrl: config.serverUrl + "Facebook/CheckChannelCampaigns",
  facebookCheckTokenUrl: config.serverUrl + "Facebook/CheckToken",
  facebookClearChannelCampaignsUrl: config.serverUrl + "Facebook/ClearChannelCampaigns",
  facebookCampaignUrl: config.serverUrl + "Facebook/GetFacebookCampaign",
  facebookConnectDataUrl: config.serverUrl + "Facebook/GetFacebookConnectData",
  facebookPageUrl: config.serverUrl + "Facebook/Index",
  facebookLoginChannelCampaignsUrl: config.serverUrl + "Facebook/LoginChannelCampaigns",
  facebookLoginCustomerUrl: config.serverUrl + "Facebook/LoginFacebookCustomer",
  facebookRepairTokenUrl: config.serverUrl + "Facebook/RepairToken",
  facebookSendConnectMessageUrl: config.serverUrl + "Facebook/SendConnectMessage",
  outbrainLoginCustomerUrl: config.serverUrl + "Outbrain/LoginOutbrainAccount",
  outbrainConnectDataUrl: config.serverUrl + "Outbrain/GetOutbrainConnectData",
  outbrainSendConnectMessageUrl: config.serverUrl + "Outbrain/SendConnectMessage",
  outbrainPageUrl: config.serverUrl + "Outbrain/Index",
  tiktokLoginCustomerUrl: config.serverUrl + "TikTok/LoginTikTokAccount",
  tiktokConnectDataUrl: config.serverUrl + "TikTok/GetTikTokConnectData",
  tiktokSendConnectMessageUrl: config.serverUrl + "TikTok/SendConnectMessage",
  tiktokPageUrl: config.serverUrl + "TikTok/Index",
  linkedinLoginCustomerUrl: config.serverUrl + "Linkedin/LoginLinkedinAccount",
  linkedinConnectDataUrl: config.serverUrl + "Linkedin/GetLinkedinConnectData",
  linkedinSendConnectMessageUrl: config.serverUrl + "Linkedin/SendConnectMessage",
  linkedinPageUrl: config.serverUrl + "Linkedin/Index",
  googleCampaignUrl: config.serverUrl + "Google/GetGoogleCampaign",
  googleCheckChannelCampaignsUrl: config.serverUrl + "Google/CheckChannelCampaigns",
  googleCheckTokenUrl: config.serverUrl + "Google/CheckToken",
  googleClearChannelCampaignsUrl: config.serverUrl + "Google/ClearChannelCampaigns",
  googleConnectCampaignUrl: config.serverUrl + "Google/ConnectCampaign",
  googleLoginCustomerUrl: config.serverUrl + "Google/ConnectGoogleCustomer",
  googleConnectDataUrl: config.serverUrl + "Google/GetGoogleConnectData",
  googlePageUrl: config.serverUrl + "Google/Index",
  googleRepairTokenUrl: config.serverUrl + "Google/RepairToken",
  googleSendConnectMessageUrl: config.serverUrl + "Google/SendConnectMessage",
  tableSettingsUrl: config.serverUrl + "KendoGrid/GetTableSettings",
  saveTableSettingsUrl: config.serverUrl + "KendoGrid/SaveGridState",
  editLandPageUrl: config.serverUrl + "LandPages/Edit",
  adGroupsUrl: config.serverUrl + "MultiSelect/AdGroupsByChannel",
  adTitlesUrl: config.serverUrl + "MultiSelect/AdTitles",
  assetsUrl: config.serverUrl + "MultiSelect/AssetsList",
  channelsUrl: config.serverUrl + "MultiSelect/Channels",
  companiesUrl: config.serverUrl + "MultiSelect/Companies",
  projectsUrl: config.serverUrl + "MultiSelect/Projects",
  processesUrl: config.serverUrl + "MultiSelect/LeadProcesses",
  tagsUrl: config.serverUrl + "MultiSelect/Tags",
  phonesChannelsUrl: config.serverUrl + "Phones/Channels",
  updatePhoneUrl: config.serverUrl + "Phones/EditFromBody",
  phonesPageDataUrl: config.serverUrl + "Phones/GetPhonesPageData",
  phonesPromptsUrl: config.serverUrl + "Phones/GetPromtsList",
  phonesUrl: config.serverUrl + "Phones/Phones_Read",
  releasePhoneUrl: config.serverUrl + "Phones/ReleaseMaskyooPhone",
  uploadAudioFilesUrl: config.serverUrl + "Phones/UploadAudioFiles",
  editAssetUrl: config.serverUrl + "Properties/Edit",
  editSiteUrl: config.serverUrl + "Sites/Edit",
  tagsForCampaignUrl: config.serverUrl + "Tags/TagsForChannel_Read",
  tagsForCampaignUpdateUrl: config.serverUrl + "Tags/TagsForChannel_UpdateFromBody",
  userDataUrl: config.serverUrl + "Users/GetUserData",
  phonesSyncUrl: config.serverUrl + "Phones/SyncWithMaskyoo",

  maxIntValue: 2147483647,

  superAdminUserRole: "Super admin",
  agencyAdminUserRole: "Agency admin",
  leadViewerUserRole: "Lead viewer",
  checklistInProcessUserRole: "Checklist in process",
  packageCRMUserRole: "PackageCRM",
  packageFixerUserRole: "PackageFixer",
  packageFreeUserRole: "PackageFree",
};
